import React from 'react'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import classNames from 'classnames'

const styleSheet = {
    mediaImage: {
        height: '100%',
        width: '100%',
        backgroundImage: ({ url }) => `url(${url})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
    },
}

const style = injectSheet(styleSheet)

const MediaImage = ({ classes, className, children, ...props }) => (
    <div className={classNames(className, classes.mediaImage)} {...props}>
        {children}
    </div>
)

export default compose(
    style,
    pure
)(MediaImage)
